import { useMemo } from 'react'

import EditIcon from '@mui/icons-material/Edit'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { useQuery } from '@tanstack/react-query'
import Table from 'components/Table'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

export default function Pages() {
  const navigate = useNavigate()

  const { data } = useQuery<Pages[]>(QUERY_KEYS.PAGES.LIST, () =>
    ApiService.Pages.getAll(),
  )

  const columns = useMemo<GridColDef[]>(
    () => [
      { field: 'title', headerName: 'Título', flex: 1 },
      {
        field: 'link',
        headerName: 'Link',
        flex: 1,
        renderCell: (params: GridRenderCellParams<Pages>) => (
          <a
            href={`https://turismoestudantil.com.br/${params.row.link}`}
            target="_blank"
            rel="noreferrer"
          >
            {params.row.link}
          </a>
        ),
      },
      {
        field: 'actions',
        headerName: 'Ações',
        width: 80,
        sortable: false,
        renderCell: (params: GridRenderCellParams<Pages>) => {
          return (
            <>
              <EditIcon
                onClick={() => {
                  navigate(ROUTES.PAGES.EDIT(params.row.id))
                }}
              />
            </>
          )
        },
      },
    ],
    [navigate],
  )

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth={false}>
        <Box>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <Typography style={{ display: 'flex' }} sx={{ m: 1 }} variant="h4">
              Páginas
              <Typography sx={{ m: 1, color: 'gray' }} variant="h5">
                - Listar
              </Typography>
            </Typography>

            <Box sx={{ m: 1 }}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  navigate(ROUTES.PAGES.CREATE)
                }}
              >
                Adicionar
              </Button>
            </Box>
          </Box>
        </Box>

        <Card sx={{ mt: 3 }}>
          <CardContent>
            <Table rows={data} columns={columns} />
          </CardContent>
        </Card>
      </Container>
    </Box>
  )
}
